import { useTranslation } from 'react-i18next';
import { sections } from './constants';
import type { ProfileSection } from './types';

interface ProfileTabsProps {
	activeSection: ProfileSection;
	onSectionChange: (section: ProfileSection) => void;
}

export default function ProfileTabs({ activeSection, onSectionChange }: ProfileTabsProps) {
	const { t } = useTranslation('profile');

	return (
		<nav className="profile-page__tabs" aria-label={t('tabs.aria')}>
			{sections.map((section) => (
				<button
					key={section}
					type="button"
					className={`profile-page__tab ${activeSection === section ? 'is-active' : ''}`}
					onClick={() => onSectionChange(section)}
				>
					{t(`tabs.${section}`)}
				</button>
			))}
		</nav>
	);
}